import { actions } from '@grandvisionhq/state';
import './add-to-cart/actions.js';
import './bundles/actions.js';
import './configurations/actions.js';
import './data-layer/actions.js';

const startPrescriptionGlassesConfiguration = actions.action('products/prescription-glasses/start', actions.payload());

export { startPrescriptionGlassesConfiguration };
//# sourceMappingURL=actions.js.map
